import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    amber: { main: string };
  }
  interface PaletteOptions {
    amber?: { main: string };
  }
}

export const CARD_PADDING = '20px';

const caseStatusTheme = createTheme({
  palette: {
    primary: {
      main: '#003f5f',
    },
    secondary: {
      main: '#007698',
    },
    success: {
      main: '#2e7d32',
    },
    warning: {
      main: '#e65100',
    },
    error: {
      main: '#d32f2f',
    },
    amber: {
      main: '#b26a00',
    },
    background: {
      default: '#f8f8f8',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Geist", "PT Sans", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          padding: CARD_PADDING,
          marginBottom: '16px',
        },
      },
    },
  },
});

export default caseStatusTheme;
